import angular from 'angular'
import routers from './routers'
import portSetUpCtrl from './portSetUpCtrl'
import addportSetUpCtrl from './add'

export default angular
    .module('system.settingcenter.portSetUp', []).config(['$stateProvider', ($stateProvider) => {
        Object.keys(routers).forEach((router) => {
            $stateProvider.state(routers[router].state, routers[router].config)
        })
    }])
    .controller('portSetUpCtrl', portSetUpCtrl)
    .controller('addportSetUpCtrl', addportSetUpCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/system/settingcenter/portSetUp/index.js